import React from "react";
import { ShieldCheck } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";
import Bubbles from "@/components/site/Bubbles";
import OfferCard from "@/components/site/OfferCard";

export default function Pricing() {
  return (
    <section className="relative overflow-hidden bg-ocean-deep py-24 md:py-32 light-rays" data-testid="pricing-section">
      <Bubbles count={14} />
      <div className="relative z-10 mx-auto max-w-2xl px-6 lg:px-8">
        <Reveal className="text-center">
          <Overline className="text-sun">Oferta por tempo limitado</Overline>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-white sm:text-5xl">
            O melhor preço do ano
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <OfferCard source="Seção Oferta de Hoje" testid="pricing" />
        </Reveal>

        <Reveal delay={0.15} className="mt-10">
          <div
            className="mx-auto max-w-xl rounded-3xl border-2 border-sun/40 bg-white/10 p-6 backdrop-blur-md sm:p-8"
            data-testid="pricing-guarantee"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-sun text-white shadow-2xl shadow-sun/40 sm:h-20 sm:w-20">
                <ShieldCheck className="h-9 w-9 sm:h-11 sm:w-11" strokeWidth={2} />
              </div>
              <div>
                <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-sun">
                  Compra sem risco
                </p>
                <h3 className="mt-1 font-display text-2xl font-black uppercase leading-tight tracking-tight text-white sm:text-3xl">
                  30 dias de garantia total
                </h3>
              </div>
            </div>
            <p className="mt-5 text-base leading-relaxed text-white/90 sm:text-lg">
              Se você <strong className="font-bold text-white">desistir</strong>, tiver algum{" "}
              <strong className="font-bold text-white">imprevisto</strong> ou até mesmo{" "}
              <strong className="font-bold text-white">
                não encontrar uma data na agenda virtual
              </strong>
              , é só chamar nosso atendimento — devolvemos <strong className="font-bold text-sun">100% do valor do ingresso.</strong>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
